const findMinMaxInswing = (
  equal: boolean,
  sideLites: string,
  swingType: string,
  isPico: boolean,
  isPivot?: boolean,
) => {
  if (!swingType) return { min: 0, max: 0 };

  let limits = {};

  if (isPivot) {
    if (equal) {
      limits = {
        "Add Single Sidelite": { min: 60, max: 124 },
        "Add Double Sidelite": { min: 89.875, max: 185.875 },
      };
    } else {
      limits = {
        none: { min: 30.125, max: 98.125 },
        "Add Single Sidelite": { min: 60, max: 160 },
        "Add Double Sidelite": { min: 89.875, max: 221.875 },
      };
    }

    return {
      min: limits[sideLites]["min"],
      max: limits[sideLites]["max"],
    };
  }

  if (isPico) {
    limits = {
      "Single Swing": {
        none: { min: 26, max: 50.1249 },
        "Add Single Sidelite": { min: 38, max: 99.9999 },
        "Add Double Sidelite": { min: 51, max: 149.8749 },
      },
      "Pair Swing": {
        none: { min: 50, max: 98.2811 },
        "Add Double Sidelite": { min: 76, max: 198.0311 },
      },
    };
  } else {
    if (equal) {
      limits = {
        "Single Swing": {
          none: { min: 26, max: 45 },
          "Add Single Sidelite": { min: 51.9375, max: 87.9375 },
          "Add Double Sidelite": { min: 77.8125, max: 131.8125 },
        },
        "Pair Swing": {
          none: { min: 50, max: 87 },
          "Add Double Sidelite": { min: 102.4375, max: 174.4375 },
        },
      };
    } else {
      limits = {
        "Single Swing": {
          none: { min: 26, max: 45 },
          "Add Single Sidelite": { min: 38, max: 88 },
          "Add Double Sidelite": { min: 51, max: 132 },
        },
        "Pair Swing": {
          none: { min: 50, max: 87 },
          "Add Double Sidelite": { min: 76, max: 175 },
        },
      };
    }
  }
  return {
    min: limits[swingType][sideLites]["min"],
    max: limits[swingType][sideLites]["max"],
  };
};

export default findMinMaxInswing;
